import extend from 'lodash/extend';

/**
 * cookies.js
 * A complete cookies reader/writer framework
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/document.cookie
 * @see https://developer.mozilla.org/User:fusionchess
 */

/* eslint-disable prefer-template */
function set(key, value, options) {
    options = extend({
        expires: null,
        domain: null,
        path: '/',
        secure: false
    }, options || {});

    if (!key || /^(?:expires|max\-age|path|domain|secure)$/i.test(key)) {
        return false;
    }

    let expires = null;

    if (options.expires) {
        switch (options.expires.constructor) {
        case Number:
            expires = options.expires === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '; max-age=' + options.expires;
            break;
        case String:
            expires = '; expires=' + options.expires;
            break;
        case Date:
            expires = '; expires=' + options.expires.toUTCString();
            break;
        }
    }

    return (document.cookie = [
        key, '=', value,
        expires ? expires : '',
        options.domain ? '; domain=' + options.domain : '',
        options.path ? '; path=' + options.path : '',
        options.secure ? '; secure' : ''
    ].join(''));
}

function has(key) {
    if (!key) {
        return false;
    }

    return (new RegExp('(?:^|;\\s*)' + key.replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=')).test(document.cookie);
}

function get(key) {
    if (!key) {
        return null;
    }

    return document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + key.replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1') || null;
}

function all() {
    return keys().reduce(function (carry, key) {
        carry[key] = get(key);

        return carry;
    }, {});
}

function remove(key, options) {
    if (!has(key)) {
        return false;
    }

    return set(key, '', extend({
        expires: 'Thu, 01 Jan 1970 00:00:00 GMT'
    }, options || {}));
}

function keys() {
    if (!document.cookie.length) {
        return [];
    }

    let cookies = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, '').split(/\s*(?:\=[^;]*)?;\s*/);

    for (let length = cookies.length, i = 0; i < length; i++) {
        cookies[i] = cookies[i];
    }

    return cookies;
}

export default {
    set,
    has,
    get,
    all,
    remove
};



// WEBPACK FOOTER //
// ./src/javascripts/lib/common/cookies.js